export default __webpack_public_path__ + "static/media/Section1-mainsvg.63ea48cb.svg";